import { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { createClient } from "@/prismicio";

const MapboxVillesMarkers = ({
  style = "mapbox://styles/mapbox/streets-v11",
  defaultCenter = [2.2137, 46.6034], 
  defaultZoom = 4.2,                  
  height = 400,
  borderRadius = "16px"
}) => {
  const mapContainer = useRef(null);

  useEffect(() => {
    let mapInstance;

    async function fetchVillesAndDisplayMarkers() {
      const client = createClient();
      const villes = await client.getAllByType("ville");

      const centerLng = defaultCenter[0];
      const centerLat = defaultCenter[1];

      mapboxgl.accessToken = "pk.eyJ1IjoieWVzeWVzcGFkZWwiLCJhIjoiY21mY3F5N3k2MDFhdDJtczMyNTVhb2swbSJ9.W7qduyKmwajnJcWq8JNX0A";
      mapInstance = new mapboxgl.Map({
        container: mapContainer.current,
        style,
        center: [centerLng, centerLat],
        zoom: defaultZoom,
      });

      villes.forEach(ville => {
        const lng = ville?.data?.geolocation?.longitude;
        const lat = ville?.data?.geolocation?.latitude;
        if (lng && lat) {
          const el = document.createElement('div');
          el.style.backgroundImage = 'url(/lieu-yyp.svg)';
          el.style.width = '26px';
          el.style.height = '33px';
          el.style.backgroundSize = '100%';

          const marker = new mapboxgl.Marker(el, { anchor: "bottom" })
            .setLngLat([lng, lat]);

          if (ville?.data?.name) {
            marker.setPopup(
              new mapboxgl.Popup().setHTML(`
                <div style="padding: 8px; min-width: 180px; color:#003a33">
                  <img src="/yy-green.svg" style="width:40px; margin-bottom: 8px;" />
                  <p style="margin-bottom:12px;">${ville.data.name}</p>
                  <a class="bouton"
                    href="${ville.url}" 
                    target="" 
                  >
                    Je joue ici
                  </a>
                </div>
              `)
            );
          }

          marker.addTo(mapInstance);
        }
      });
    }

    fetchVillesAndDisplayMarkers();

    return () => {
      if (mapInstance) mapInstance.remove();
    };
  }, [style, defaultCenter, defaultZoom]);

  return (
    <div
      ref={mapContainer}
      style={{
        width: "100%",
        height,
        borderRadius,
        overflow: "hidden"
      }}
    />
  );
};

export default MapboxVillesMarkers;